module.exports = __webpack_public_path__ + "bd29dbba02917da933a2ce03d5e85e04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2_2023_chart.png
// module id = 1657
// module chunks = 0